<div class="headermaster">
  <div class="row">
    <div class="col-md-4 pl-0">
      <nav class="navbar navbar-expand-sm top-banner">
        <img src="../../assets/images/logo.png" width="80" />
        <ul class="navbar-nav ml-2">
          <li class="nav-item">
            <div class="contentheader">สถาบันคุ้มครองเงินฝาก (สคฝ.)</div>
            <div class="contentheader2">Deposit Protection Agency(DPA)</div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
<div class="row mt-5">
  <div class="col-5 my-auto mx-auto bg-white p-3 rounded border-top border-primary">
    <div class="row">
      <div class="col-12 text-center">
        <h3 class="text-primary">กำหนดรหัสผ่านใหม่</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form>
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="username" readonly>
          </div>
          <div class="form-group">
            <label for="newPass">รหัสผ่านใหม่</label>
            <input type="password" class="form-control" name="newPass" [(ngModel)]="newPass" [disabled]="isResetSuccess">
            <span class="text-danger" *ngIf="submitted && newPass.trim() == ''">
              กรุณาระบุ รหัสผ่านใหม่
            </span>
            <span class="text-danger" *ngIf="submitted && newPass.trim() != '' && passwordValidation() == false">
              รหัสผ่านใหม่ต้องประกอบไปด้วย<br> อักษรภาษาอังกฤษตัวเล็กอย่างน้อย 1 ตัว<br> ตัวใหญ่อย่างน้อย 1 ตัว<br> ตัวเลขอย่างน้อย 1 ตัว<br> อักขระพิเศษอย่างน้อย 1 ตัว<br> ขั้นต่ำ 8 ตัวอักษรและไม่เกิน 16 ตัวอักษร
            </span>
          </div>
          <div class="form-group">
            <label for="confirmNewPass">ยืนยันรหัสผ่านใหม่</label>
            <input type="password" class="form-control" name="confirmNewPass" [(ngModel)]="confirmPass" [disabled]="isResetSuccess">
            <span class="text-danger" *ngIf="submitted && confirmPass.trim() != '' && confirmPass != newPass">
              กรุณาระบุ ยืนยันรหัสผ่านใหม่ ให้ตรงกับ รหัสผ่านใหม่
            </span>
            <span class="text-danger" *ngIf="submitted && confirmPass.trim() == ''">
              กรุณาระบุ ยืนยันรหัสผ่านใหม่
            </span>
          </div>
        </form>

      </div>
      <div class="col-12 text-center" *ngIf="isExistingUser">
        <button type="button" class="btn btn-primary m-2" (click)="changePassword()" [disabled]="isResetSuccess">กำหนดรหัสผ่านใหม่</button>
        <button type="button" class="btn btn-primary m-2" (click)="clear()" [disabled]="isResetSuccess">ล้างค่า</button>
        <button type="button" class="btn btn-primary m-2" (click)="close()">ปิด</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/set-new-password/set-new-password.component.html